import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Axios, { AxiosInstance, AxiosResponse } from "axios";
import { Environment } from "@/common/environment";
import { UserModel } from "@/models/UserModel";
import { CompanyModel } from "@/models/CompanyModel";
import eventBus from "@/common/bus";
import DepartmentModel from "@/models/DepartmentModel";
import DepartmentService from "@/services/department.service";

@Module({ name: "StoreVuexModule" })
export default class StoreVuexModule extends VuexModule {
  private token = "";
  private WorkerEmail = "";
  private Environment: Environment = new Environment();
  private User: UserModel | null = null;
  private Company: CompanyModel | null = null;
  private Departments: DepartmentModel[] = [];
  private CompanyAPIKey = "";

  @Mutation
  public setEnvironment(environment: Environment) {
    this.Environment = environment;
  }

  @Mutation
  public setApiToken(token: string) {
    this.token = token;
  }

  @Mutation
  public setWorkerEmail(email: string) {
    this.WorkerEmail = email;
  }

  @Mutation
  public setUser(user: UserModel | null) {
    this.User = user;
  }

  @Mutation
  public setCompany(company: CompanyModel | null) {
    this.Company = company;
  }

  @Mutation
  public setDepartments(departments: DepartmentModel[]) {
    this.Departments = departments;
  }

  @Mutation
  public setCompanyAPIKey(companyAPIKey: string) {
    this.CompanyAPIKey = companyAPIKey;
  }

  @Action
  public async loadEnvironment(): Promise<[boolean, string]> {
    let res: AxiosResponse<Environment> | null = null;
    try {
      res = await Axios.get<Environment>("/environment.json", {
        validateStatus: () => true,
      });
    } catch (err) {
      // tslint:disable-next-line: no-console
      return [false, "failed to load environment.json"];
    }

    if (res.status !== 200 || !res.data) {
      return [false, `failed to load environment.json (${res.status})`];
    }

    this.context.commit("setEnvironment", Object.assign(new Environment(), res.data));
    return [true, ""];
  }

  @Action
  public async setupUser(): Promise<[boolean, number]> {
    if (this.user) {
      return [true, 200];
    }

    let res: AxiosResponse<UserModel> | null = null;
    eventBus.$emit("loading", true);
    try {
      res = await Axios.get<UserModel>(`/User/profile`, {
        baseURL: this.environment.ApiBaseUrl,
        headers: {
          Authorization: `Bearer ${this.apiToken}`,
        },
        validateStatus: () => true,
      });
    } catch (error) {
      eventBus.$emit("loading", false);
      // tslint:disable-next-line: no-console
      if (error.message === "Network Error") {
        return [true, 509];
      }
      return [false, 500];
    }

    if (res.data) {
      this.context.commit("setUser", res.data);
    }

    eventBus.$emit("loading", false);

    return [true, res.status];
  }

  public get baseApiUrl(): string {
    return this.Environment.ApiBaseUrl;
  }

  public get environment(): Environment {
    return this.Environment;
  }

  public get apiToken(): string {
    return this.token;
  }

  public get workerEmail(): string {
    return this.WorkerEmail;
  }

  public get user(): UserModel | null {
    return this.User;
  }

  public get company(): CompanyModel | null {
    return this.Company;
  }

  public get departments(): DepartmentModel[] {
    return this.Departments;
  }

  public get companyAPIKey(): string {
    return this.CompanyAPIKey;
  }
}
